import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../components/common/Providers/AuthProvider";

const ProtectedRoute = ({ children }: { children: React.ReactNode}) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null; // или спиннер загрузки
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute;